import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";

export interface ImportJobCount extends AttributesMixin<typeof ImportJobCount> { }

@define
export class ImportJobCount extends Model {
  static endpoint = restfulIO('api/v1/ingest/import-jobs/count');

  static attributes = {
    count: Number
  }

  parse(number: Number) {
    return { count: number }
  }
}
